import React from "react";
import ReporteVentasAnuladas from "../components/ReporteVentasAnuladas";

const InformeVentasAnuladas = () => {
  return (
    <>
      <ReporteVentasAnuladas />
    </>
  );
};

export default InformeVentasAnuladas;